import { roleTypeIconClass, roleTypeLabel,roleTypeDescription } from './sp-role-type.exports';

export class Controller {

    $onChanges() {
        this.tooltipKey = roleTypeLabel(this.roleType);
        this.tooltipDesc = roleTypeDescription(this.roleType);
        this.iconClass = `text-primary fa fa-lg ${roleTypeIconClass(this.roleType)}`;
        
      
    }
}



// WEBPACK FOOTER //
// ./src/portal/components/sp-role-type/sp-role-type.controller.js